import { useState, useEffect } from 'react';
import { CometChat } from '@cometchat/chat-sdk-javascript';

const useNewMessageCount = (currentRoute) => {
  const [newMessageCount, setNewMessageCount] = useState(0);

  // Fetch existing unread count on initial render
  const fetchUnreadCount = async () => {
    try {
      const user = await CometChat.getLoggedinUser();
      if (user) {
        const unreadCount = await CometChat.getUnreadMessageCount();
        console.log('getUnreadMessageCount', { unreadCount });

        const totalUnread = Object.values(unreadCount)
          .flatMap((counts) => Object.values(counts))
          .reduce((acc, count) => acc + count, 0);

        setNewMessageCount(totalUnread);
        localStorage.setItem('newMessageCount', totalUnread.toString());
      }
    } catch (error) {
      console.error('Error fetching unread count:', error);
    }
  };

  useEffect(() => {
    // Initialize unread count
    fetchUnreadCount();

    const listenerID = 'CHAT_UI_NEW_MESSAGE_LISTENER';

    // Listen for new messages
    CometChat.addMessageListener(
      listenerID,
      new CometChat.MessageListener({
        // params: message: CometChat.Message
        onTextMessageReceived: () => {
          if (currentRoute !== '/freelancer/messages') {
            setNewMessageCount((prevCount) => {
              const updatedCount = prevCount + 1;
              localStorage.setItem('newMessageCount', updatedCount.toString());
              return updatedCount;
            });
          }
        },
      })
    );

    return () => {
      CometChat.removeMessageListener(listenerID);
    };
  }, [currentRoute]);

  const clearCount = () => {
    setNewMessageCount(0);
    localStorage.setItem('newMessageCount', '0');
  };

  return { newMessageCount, clearCount };
};

export default useNewMessageCount;
